module.exports = __webpack_public_path__ + "img/SP-WX-FEATURE2.d96c6fc.png";